// The API issues tokens in the JSON response body (see
// documentation/api/API_OVERVIEW.md), not as Set-Cookie headers, so
// there's no httpOnly cookie option here without a backend change —
// localStorage is the pragmatic choice for this build. The CSP set by
// SecurityHeadersMiddleware.php (default-src 'none') meaningfully
// reduces XSS exfiltration risk since the API itself never renders
// third-party content, but this is a real tradeoff worth revisiting if
// the API ever grows a cookie-issuing login endpoint.

const ACCESS_TOKEN_KEY = 'pp_access_token';
const REFRESH_TOKEN_KEY = 'pp_refresh_token';
const ORGANIZATION_ID_KEY = 'pp_organization_id';
const DEVICE_ID_KEY = 'pp_device_id';

export interface StoredTokens {
  accessToken: string;
  refreshToken: string;
  organizationId: number;
}

export function saveTokens(tokens: StoredTokens): void {
  localStorage.setItem(ACCESS_TOKEN_KEY, tokens.accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken);
  localStorage.setItem(ORGANIZATION_ID_KEY, String(tokens.organizationId));
}

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function getOrganizationId(): number | null {
  const raw = localStorage.getItem(ORGANIZATION_ID_KEY);
  return raw ? Number(raw) : null;
}

export function clearTokens(): void {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(ORGANIZATION_ID_KEY);
}

/** Stable per-browser identifier sent as X-Device-Id so "Active Devices" can tell sessions apart. */
export function getOrCreateDeviceId(): string {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
}
